import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Card,
  Center,
  Container,
  Flex,
  Grid,
  Group,
  Input,
  Loader,
  Modal,
  Select,
  Text,
  createStyles,
} from "@mantine/core";
import { IconFilter } from "@tabler/icons-react";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import React, { useRef } from "react";
// import * as XLSX from "xlsx";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getNotesByReport } from "../../services/note";
import { getMARReport, sendReportEmail } from "../../services/report";
import {
  decrypt,
  formatDate,
  formatTime,
  getOptions,
  showInfo,
} from "../../utils";
import ReportButton from "../ReportButton";
import ReportEmailModal from "../ReportEmailModal";
import ReportViewTable from "../ReportViewTable";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReportViewTableProgress from "../ReportViewTableProgress";
import TaskReportViewTable from "../TaskReportViewTable";
import moment from "moment";
import { getSubTask } from "../../services/task";
import MARReportViewTable from "../MarReportView/MARReportViewTable";
import MarViewReportModal from "../../pages/Home/Medication/MarViewModal";
import { getAllPatientsModal } from "../../services/patient";
import { getAllFacilitiesModal } from "../../services";
import { getAllStaff } from "../../services/staff";
import ReportViewTableEssentialNote from "../ReportViewTableEsseentialNote";
import ReportViewTableIntervention from "../ReportViewTableInterventions";
const ReportViewModal = ({
  opened,
  onclose,
  viewEmail,
  setViewEmail,
  title,
  save,
  ...data
}) => {
  const { classes } = useStyles();
  const { profile, saveProfileLoading } = useSelector(
    (state) => state?.profile
  );
  const { allSignature } = useSelector((state) => state?.signature);

  // const [tables, setTables] = useState(
  //   data?.data?.parameters?.filter((value) => value?.source)
  // );

  const [tables, setTables] = useState([]);

  useEffect(() => {
    if (data?.data?.reportType === "task") {
      setTables(data?.data?.taskParameters?.filter((value) => value?.fields));
      getSubTask();
    } else if (data?.data?.reportType === "note") {
      setTables(data?.data?.parameters?.filter((value) => value?.source));
    }
  }, [data?.data?.reportType]);

  const { allPatients } = useSelector((state) => state?.patient);

  const { allFacilities } = useSelector((state) => state?.facility);

  const { staff } = useSelector((state) => state?.staff);

  const { notesAgainstTypes, allNotesTypes, noteTypes } = useSelector(
    (state) => state?.note
  );

  const { taskTypes, subTask } = useSelector((state) => state?.task);
  const [length, setLength] = useState(0);
  const [error, setError] = useState("");
  const [filteredTasks, setFilteredTasks] = useState(null);
  const [marReportData, setMarReportData] = useState(null);
  const [marLoading, setMarLoading] = useState(false);

  const [marTable, setMarTable] = useState(null);
  const [filteredMar, setFilteredMar] = useState(null);

  const [emailState, setEmailState] = useState("");

  const ref = useRef();
  const sourceOptions = tables?.map((value) => ({
    label: value?.source?.name,
    value: value?.source?.id,
  }));

  const marFieldOptions = marTable?.[0]?.fields;

  const initialFilters = [
    {
      field: "",
      fieldValue: "",
      filterOn: "",
      source: "",
      id: 343423909243,
      fieldOptions: [],
      fieldValueOptions: [],
      filterOptions: [],
    },
  ];
  const hasProgressNote =
    tables?.find((v) => v?.source?.name === "Progress Note") ||
    tables?.find((v) =>
      v?.source?.custom?.find(
        (_c) => _c?.field === "Support Plan" && v?.source?.general === false
      )
    );

  const hasEssentialNote = tables?.find(
    (v) => v?.source?.name === "Essential Support Note"
  );
  const hasInterventionNote = tables?.find(
    (v) => v?.source?.name === "Intervention Progress Note"
  );

  console.log("🚀 ~ ReportViewModal ~ data:", hasInterventionNote);

  const [filters, setFilters] = useState(initialFilters);
  useEffect(() => {}, [filters]);
  const [taskFilters, setTaskFilters] = useState([]);
  useEffect(() => {}, [taskFilters]);
  const [filteredData, setFilteredData] = useState({});
  const [filterField, setFilterField] = useState([]);
  const [pdfDownloadloading, setPdfDownloadloading] = useState(false);
  // const getMARReportLocal = async () => {
  //   const res = await getMARReport(data?.data?.id, false);
  //   if (res) {
  //     setMarLoading(false);
  //     setMarReportData(res);
  //     setMarLoading(false);
  //   }
  // };

  const getMARReportLocal = async () => {
    try {
      setMarLoading(true);
      const res = await getMARReport(data?.data?.id, false);
      if (res) {
        setMarReportData(res);
      }
    } catch (error) {
    } finally {
      setMarLoading(false);
    }
  };

  useEffect(() => {
    if (tables && opened) {
      if (data?.data?.reportType === "mar") {
        getMARReportLocal();
      } else {
        getNotesByReport(data?.data?.id);
      }
    }
  }, [tables, opened]);

  useEffect(() => {
    if (notesAgainstTypes?.notes?.length) {
      if (!allPatients) {
        getAllPatientsModal();
      }

      if (!allFacilities?.facilities) {
        getAllFacilitiesModal("all");
      }

      if (!staff?.staffs) {
        getAllStaff();
      }
      // getAllFacilitiesModal
      // getAllStaff
    }
  }, [notesAgainstTypes]);

  useEffect(() => {
    if (data?.data?.reportType === "task") {
      if (data?.data?.taskParameters && taskTypes?.length) {
        let _tables = data?.data?.taskParameters?.map((value) => {
          let ref_array = [
            "Facility Name",
            "Task Name",
            "Client Name",
            "Shift",
            "Date",
            "Staff Name",
            "Time",
            "Task Completed",
            "Activities Performed",
            "Notes",
          ];

          let sortedHeaders = [];
          if (value?.fields?.length > 0) {
            sortedHeaders = [...value?.fields]?.sort(
              (a, b) => ref_array?.indexOf(a) - ref_array?.indexOf(b)
            );
          }

          return {
            ...value,
            fields: sortedHeaders,
            source: taskTypes?.find(
              (taskType) => taskType?.id === value?.source?.id
            ),
          };
        });
        setTables(_tables);
      }
    } else if (data?.data?.reportType === "note") {
      console.log("🚀 ~ value:", noteTypes);
      if (data?.data?.parameters && noteTypes?.ntypes?.length) {
        let _tables = data?.data?.parameters?.map((value) => {
          return {
            ...value,
            source: noteTypes?.ntypes?.find(
              (noteType) => noteType?.id === value?.source?.id
            ),
          };
        });
        setTables(_tables);
      }
    }
  }, [data?.data?.reportType, taskTypes]);

  useEffect(() => {
    if (marReportData && marReportData?.length) {
      let ref_array = [
        "Date",
        "Client Name",
        "Medication Name",
        "Dosage",
        "Route",
        "Narcotic",
        "Remaining Qty",
        "Administration Type",
        "Scheduled Time",
        "Administered Time",
        "Staff Name",
        "Outcome",
      ];

      let _table = {
        fields: ref_array,
        source: marReportData,
      };

      setMarTable([_table]);
    }
  }, [marReportData]);

  // functions

  const addEmptyFilter = () => {
    setFilters((p) => [
      ...p,
      {
        field: "",
        fieldValue: "",
        filterOn: "",
        fieldOptions: [],
        fieldValueOptions: [],
        filterOptions: [],
        id: Date.now(),
      },
    ]);
  };
  const removeFilters = () => {
    setFilters(initialFilters);
    setError("");
    ref?.current?.applyFilters("clear");
  };
  const removeFilter = (id) => {
    setFilters((p) => p?.filter((val) => val?.id !== id));
    setError("");
  };
  // Source change handler
  const onChangeSource = (source, id) => {
    if (data?.data?.reportType === "task") {
      let fields = tables?.find((value) => value?.source?.id === source);
      // setTaskFilters(fields?.fields)
      setFilters((p) =>
        p?.map((val) =>
          val?.id === id
            ? {
                ...val,
                source: source,
                fieldOptions: fields?.fields
                  ?.map((item) => ({ label: item, value: item }))
                  ?.filter(
                    (val) =>
                      val?.value !== "Task Name" &&
                      val?.value !== "Time" &&
                      val?.value !== "Shift" &&
                      val?.value !== "Task Completed" &&
                      val?.value !== "Activities Performed" &&
                      val?.value !== "Staff Name" &&
                      val?.value !== "Notes"
                  ),
                fieldValue: "",
                filterOn: "",
                field: "",
              }
            : val
        )
      );
    } else {
      let fields = tables?.find((value) => value?.source?.id === source);
      fields = fields?.source?.custom
        ?.filter((v) => {
          if (fields?.fields?.length > 0) {
            return fields?.fields?.includes(v?._id);
          } else return true;
        })
        ?.map((val) => ({
          label: val?.field,
          value: val?._id,
        }));

      setFilters((p) =>
        p?.map((val) =>
          val?.id === id
            ? {
                ...val,
                source: source,
                fieldOptions: fields,
                fieldValue: "",
                filterOn: "",
                field: "",
              }
            : val
        )
      );
    }
  };
  // Field change handler
  const onChangeField = (fieldToFilter, id) => {
    if (data?.data?.reportType === "task") {
      const source = filters?.find((val) => val?.id === id);

      const fieldName = source?.fieldOptions?.find(
        (field) => field?.value === fieldToFilter
      )?.label;

      source.fieldValue = fieldToFilter;
      source.filterOn = "";
      let tasks = notesAgainstTypes?.tasks;

      let filteredVals = [];

      if (fieldName === "Client Name") {
        filteredVals = tasks?.map((task) => {
          return decrypt(task?.client?.name, false);
        });
      } else if (fieldName === "Facility Name") {
        filteredVals = tasks?.map((task) => {
          return task?.facility?.name;
        });
      } else if (fieldName === "Date") {
        filteredVals = tasks?.map((task) => {
          return moment(task?.dateTime).format("MM-DD-YYYY");
        });
      }
      // else if(fieldName === "Shift"){
      //   tasks?.map((task) => {
      //     task?.fieldsDone?.map((val) => filteredVals.push(val?.shift))
      //   })
      // } else if(fieldName === "Task Completed"){
      //   tasks?.map((task) => {
      //     task?.fieldsDone?.map((val) => filteredVals.push(val?.field?.name))
      //   })
      // } else if(fieldName === "Time"){
      //   filteredVals = tasks?.map((task) => {return moment(task?.dateTime).format("MM-DD-YYYY")})
      //   // moment(doneVal?.field?.createdAt).format("hh:mm a")
      // }

      let uniq = filteredVals?.reduce(function (a, b) {
        if (a.indexOf(b) < 0) a.push(b);
        return a;
      }, []);

      source.filterOptions = uniq?.map((item) => {
        return { label: item, value: item };
      });

      // source.filterOptions = tasks
      // ?.filter((v) => {
      //   let patient =
      //     fieldName === "Client Name"
      //       // ? decrypt(v?.client?.name, false) && !v?.fields?.["Client Name"]
      //       ? decrypt(v?.client?.name, false) && !v?.fields?.["Client Name"]
      //         ? "Patient Name"
      //         : v?.fields?.["Patient Name"] && v?.fields?.["Client Name"]
      //         ? "Client Name"
      //         : "Client Name"
      //       : fieldName;
      //       return patient
      //   // return v?.fields[patient];
      // })

      setFilters((p) =>
        p?.map((val) =>
          val?.id === id && val?.fieldValue === fieldName ? source : val
        )
      );
    } else {
      const source = filters?.find((val) => val?.id === id);
      const fieldName = source?.fieldOptions?.find(
        (field) => field?.value === fieldToFilter
      )?.label;

      source.fieldValue = fieldToFilter;
      source.filterOn = "";
      let notes = notesAgainstTypes?.notes
        ?.filter((val) => val?.noteId === source?.source)
        ?.map((val) => ({
          ...val,
          populate: noteTypes.ntypes?.find(
            (value) => value?.id === val?.noteId
          ),
        }));

      let unique = [];
      source.filterOptions = notes
        ?.filter((v) => {
          let patient =
            fieldName === "Client Name"
              ? v?.fields?.["Patient Name"] && !v?.fields?.["Client Name"]
                ? "Patient Name"
                : v?.fields?.["Patient Name"] && v?.fields?.["Client Name"]
                ? "Client Name"
                : "Client Name"
              : fieldName;
          return v?.fields[patient];
        })
        // ?.filter((v) => v?.fields[fieldName])
        ?.map((value) => {
          let patient =
            fieldName === "Client Name"
              ? value?.fields?.["Patient Name"] &&
                !value?.fields?.["Client Name"]
                ? "Patient Name"
                : value?.fields?.["Patient Name"] &&
                  value?.fields?.["Client Name"]
                ? "Client Name"
                : "Client Name"
              : fieldName;

          let fromCustom = value?.populate?.custom?.find(
            (value) => value?.field === fieldName
          );
          let options = fromCustom?.options;
          if (options) {
            let array = getOptions(options, value?.populate?.custom);
            let single = array?.find(
              (val) => val?.value === value?.fields[patient]
            );
            if (single) return single;
            else
              return {
                value: value?.fields[patient],
                label: formatDate(value?.fields[patient]),
              };
          } else {
            // allFacilities
            // staff
            let tempLabel = "";
            if (patient == "Client Name") {
              tempLabel =
                allPatients?.find((item) => item?.id == value?.fields[patient])
                  ?.name || "-";
            } else if (patient == "Facility Name") {
              tempLabel =
                allFacilities?.facilities?.find(
                  (item) => item?.id == value?.fields[patient]
                )?.name || "-";
            } else if (patient == "Staff Name") {
              tempLabel =
                staff?.staffs?.find(
                  (item) => item?.id == value?.fields[patient]
                )?.name || "-";
            } else {
              tempLabel = value?.fields[patient];
            }
            return {
              value: value?.fields[patient],
              // label: formatDate(value?.fields[patient]),
              label: tempLabel,
            };
          }
        });

      source?.filterOptions?.forEach((value) => {
        if (!unique?.find((v) => v?.value === value?.value)) {
          unique.push(value);
        }
      });

      source.filterOptions = unique;

      source.field = fieldName;

      setFilters((p) => p?.map((val) => (val?.id === id ? source : val)));
    }
  };

  const onChangeMarField = (fieldToFilter, id) => {
    const source = filters?.find((val) => val?.id === id);

    source.fieldValue = fieldToFilter;
    source.filterOn = "";

    let mar = marTable?.[0]?.source;

    let _mar = [];
    mar?.forEach((v, i) => {
      const _decrypt = decrypt(v?.client?.form3);
      const filtered = _decrypt?.find(
        (x) => Number(x?.id) === Number(v?.medicationId)
      );
      if (filtered) {
        _mar.push({
          ...v,
          form3: filtered ? filtered : null,
        });
      }
    });

    let marFormattedSource = _mar?.map((item) => {
      return {
        date: item?.date,
        medicationName: item?.form3?.medicationName || "-",
        clientName: decrypt(item?.client?.name, false) || "-",
        dosage: item?.dosage || "-",
        route: item?.form3?.ingestionMode || "-",
        narcotic: item?.form3?.isNarcotic || "-",
        remainQty: item?.medicineRemaining || "-",
        administrationType: item?.form3?.frequency || "-",
        schedule: item?.timeSlot || "-",
        staffName: item?.staff?.name || "-",
        administeredTime: item?.staff
          ? formatTime(item?.createdAt)
          : "-" || "-",
        outcome:
          item?.medicationType === "upcoming"
            ? !moment(item.date).isBefore(moment().format("MM-DD-YYYY"))
              ? "Upcoming"
              : "Missed"
            : item?.medicationType,
      };
    });

    // let ref_array = [
    //   "Date",
    //   "Client Name",
    //   "Medication Name",
    //   "Dosage",
    //   "Route",
    //   "Narcotic",
    //   "Remaining Qty",
    //   "Administration Type",
    //   "Scheduled Time",
    //   "Administered Time",
    //   "Staff Name",
    //   "Outcome",
    // ];

    let filteredVals = [];

    if (fieldToFilter === "Client Name") {
      filteredVals = marFormattedSource?.map((item) => {
        return item?.clientName;
      });
    } else if (fieldToFilter === "Medication Name") {
      filteredVals = marFormattedSource?.map((item) => {
        return item?.medicationName;
      });
    } else if (fieldToFilter === "Date") {
      filteredVals = marFormattedSource?.map((item) => {
        return formatDate(item?.date);
      });
    } else if (fieldToFilter === "Dosage") {
      filteredVals = marFormattedSource?.map((item) => {
        return item?.dosage;
      });
    } else if (fieldToFilter === "Route") {
      filteredVals = marFormattedSource?.map((item) => {
        return item?.route;
      });
    } else if (fieldToFilter === "Narcotic") {
      filteredVals = marFormattedSource?.map((item) => {
        return item?.narcotic;
      });
    } else if (fieldToFilter === "Remaining Qty") {
      filteredVals = marFormattedSource?.map((item) => {
        return item?.remainQty;
      });
    } else if (fieldToFilter === "Administration Type") {
      filteredVals = marFormattedSource?.map((item) => {
        return item?.administrationType;
      });
    } else if (fieldToFilter === "Scheduled Time") {
      filteredVals = marFormattedSource?.map((item) => {
        return item?.schedule;
      });
    } else if (fieldToFilter === "Administered Time") {
      filteredVals = marFormattedSource?.map((item) => {
        return item?.administeredTime;
      });
    } else if (fieldToFilter === "Staff Name") {
      filteredVals = marFormattedSource?.map((item) => {
        return item?.staffName;
      });
    } else if (fieldToFilter === "Outcome") {
      filteredVals = marFormattedSource?.map((item) => {
        return item?.outcome;
      });
    }

    let uniq = filteredVals?.reduce(function (a, b) {
      if (a.indexOf(b) < 0) a.push(b);
      return a;
    }, []);

    uniq = uniq?.filter((item) => item !== "-");

    source.filterOptions = uniq?.map((item) => {
      return { label: String(item), value: String(item) };
    });

    setFilters((p) =>
      p?.map((val) =>
        val?.id === id && val?.fieldValue === fieldToFilter ? source : val
      )
    );
  };

  const onChangeFieldValue = (filterOn, id) => {
    setFilters((p) =>
      p?.map((value) => (value.id === id ? { ...value, filterOn } : value))
    );
  };
  const sendFilters = () => {
    // let toCheck = filters?.filter((value) => value?.source);
    setFilterField(filters);
    ref?.current?.applyFilters(filters);
    // if (toCheck) {
    //   setError("");

    //   setFilterField(filters);
    //   ref?.current?.applyFilters(toCheck);
    // } else {
    //   setError(
    //     "Please check if filters are added correctly. If problem exists retry clearing filters."
    //   );
    // }
  };
  const setFiltered = (sourceid, source, dataToSet) => {
    setLength(dataToSet?.length - 1);
    setFilteredData((p) => ({
      ...p,
      [sourceid]: {
        source,
        data: dataToSet,
      },
    }));
  };
  // const exportXLSX = () => {
  //   if (Object.entries(filteredData)?.length > 0) {
  //     const wb = XLSX.utils.book_new();

  //     Object.entries(filteredData)?.map((element) => {
  //       XLSX.utils.book_append_sheet(
  //         wb,
  //         XLSX.utils.aoa_to_sheet(element?.[1]?.data),
  //         `Source: ${element?.[1]?.source?.name}`
  //       );
  //     });
  //     XLSX.writeFile(wb, "Report.xlsx");
  //   }
  // };

  const startDate = formatDate(data?.data?.startDate);
  const endDate = formatDate(data?.data?.endDate);
  // const signatureTimePDF = formatDate(profile?.user?.signatureTime);

  const loadImageAsBase64 = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = url;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png")); // ✅ Base64
      };
      img.onerror = (err) => reject(err);
    });
  };

  const preloadSignatures = async (bodyArr) => {
    for (let row of bodyArr) {
      for (let col of row) {
        if (col?.signature) {
          try {
            col.signatureBase64 = await loadImageAsBase64(col.signature);
          } catch {
            col.signatureBase64 = null;
          }
        }
      }
    }
  };

  const taskHandlePDF = async () => {
    setPdfDownloadloading(true);
    console.log("Generating PDF...");
    // Create a new jsPDF instance
    var pdfsize = [1500, 1000]; //"a0";
    var doc = new jsPDF("l", "pt", pdfsize);
    const dataURL =
      "data:image/png;base64,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";
    doc.addImage(dataURL, "PNG", 13, 10, 80, 40);
    doc.setFont("helvetica", "bold");
    doc.text(data?.data?.name || "", 750, 50, { align: "center" });
    doc.setFont("helvetica", "normal");
    doc.text(startDate, 1200, 70);
    doc.text("-", 1320, 70);
    doc.text(endDate, 1350, 70);

    const startX = 30;
    let startY = 100;

    // if () {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.text("PARAMETERS" || "", 80, 70, { align: "center" });
    doc.setFont("helvetica", "normal");

    let filtersHead = tables?.[0]?.fields?.filter((field) => field !== "Notes");
    let tasks = filteredTasks ? filteredTasks : notesAgainstTypes?.tasks || [];

    let updatedTasks = [];
    tasks?.map((item) => {
      item?.shift?.map((shiftObj) => updatedTasks.push({ ...item, shiftObj }));
    });

    let structuredArr = [];
    updatedTasks?.forEach((task) => {
      let tempStaffs = [];
      task?.fieldsDone?.map((item) => {
        if (
          tempStaffs.findIndex(
            (tempStaff) => tempStaff?.id == item?.staff?.id
          ) == -1
        ) {
          tempStaffs.push(item?.staff);
        }
      });

      let fieldsDoneAccordingToShift = task?.fieldsDone?.filter(
        (field) => field?.shift == task?.shiftObj?.name
      );

      let notesDoneAccShift = task?.notes?.filter(
        (note) => note?.shift == task?.shiftObj?.name
      );

      let staffPerformedFields = [];

      tempStaffs?.map((tempStaff) => {
        let staffFields = fieldsDoneAccordingToShift?.filter(
          (item) => item?.staff?.id == tempStaff?.id
        );
        let staffNotes = notesDoneAccShift?.filter(
          (item) => item?.staff?.id == tempStaff?.id
        );
        let completedTasks = Array.from(
          new Set(
            staffFields?.map(
              (filteredField) =>
                task?.taskType?.subTasks
                  ?.filter((subItem) =>
                    subItem?.fields?.includes(filteredField?.field?._id)
                  )
                  ?.map((taskLabel) => taskLabel?.task?.name)?.[0]
            )
          )
        );
        let checkedTimes = staffFields?.map((item) => item?.checkedAt);
        if (staffFields?.length) {
          staffPerformedFields.push({
            staff: tempStaff,
            tasks: completedTasks,
            shift: task?.shiftObj?.name,
            activities: staffFields
              ?.map((item) => item?.field?.name)
              ?.join(", "),
            notes: staffNotes,
            time: checkedTimes,
          });
        }
      });

      let tempObj = {
        client: decrypt(task?.client?.name, false),
        facility: task?.facility?.name,
        date: moment(task?.dateTime).format("MM-DD-YYYY"),
        taskType: task?.taskType?.name,
        shift: task?.shiftObj?.name,
        // expandedRow: tempStaffs?.map((staff) => {
        expandedRow: staffPerformedFields?.map((staffPerformed) => {
          return {
            staff: staffPerformed?.staff,
            tasks: staffPerformed?.tasks,
            activities: staffPerformed?.activities,
            notes: staffPerformed?.notes,
            time: moment(
              staffPerformed?.time?.[staffPerformed?.time?.length - 1]
            ).format("hh:mm a"),
          };
        }),
        fieldsDone: task?.fieldsDone?.map((item) => {
          return {
            name: item?.field?.name,
            time: moment(item?.field?.createdAt).format("hh:mm a"),
            shift: item?.shift,
            staff: item?.staff?.name,
            activity: task?.taskType?.subTasks
              ?.filter((subItem) => subItem?.fields?.includes(item?.field?._id))
              ?.map((filterSubTask) =>
                subTask?.find((sTask) => sTask?._id == filterSubTask?.task)
              ),
          };
        }),
      };
      structuredArr.push(tempObj);
    });
    structuredArr.sort(
      (a, b) =>
        moment(b.date, "MM-DD-YYYY").toDate() -
        moment(a.date, "MM-DD-YYYY").toDate()
    );

    // let tempTasks = tasks?.map((task) => {
    let tempTasks = structuredArr?.map((task) => {
      let allTempArr = [];
      task?.expandedRow?.map((expandVal, expandIndex) => {
        let tempArr = [];
        filtersHead?.map((headerVal) => {
          if (headerVal === "Facility Name") {
            // tempArr.push(task?.facility?.name || "");
            if (expandIndex === 0) {
              tempArr.push({
                content: task?.facility || "",
                rowSpan: task?.expandedRow?.length,
                styles: { halign: "center" },
              });
            }
          } else if (headerVal === "Task Name") {
            // tempArr.push(task?.taskType?.name || "");
            if (expandIndex === 0) {
              tempArr.push({
                content: task?.taskType || "",
                rowSpan: task?.expandedRow?.length,
                styles: { halign: "center" },
              });
            }
          } else if (headerVal === "Client Name") {
            // tempArr.push(decrypt(task?.client?.name, false) || "");
            if (expandIndex === 0) {
              tempArr.push({
                content: task?.client || "",
                rowSpan: task?.expandedRow?.length,
                styles: { halign: "center" },
              });
            }
          } else if (headerVal === "Date") {
            // tempArr.push(moment(task?.dateTime).format("MM-DD-YYYY") || "");
            if (expandIndex === 0) {
              tempArr.push({
                content: moment(task?.date).format("MM-DD-YYYY") || "",
                rowSpan: task?.expandedRow?.length,
                styles: { halign: "center" },
              });
            }
          } else if (headerVal === "Shift") {
            if (expandIndex === 0) {
              tempArr.push({
                content: task?.shift || "",
                rowSpan: task?.expandedRow?.length,
                styles: { halign: "center" },
              });
            }
            // tempArr.push(expandVal?.shift || "");
          } else if (headerVal === "Staff Name") {
            const sigObj = allSignature.find(
              ({ staff, admin }) =>
                (staff && staff === expandVal?.staff?.id) || (admin && admin === expandVal?.staff?.id)
            );

            tempArr.push({
              staffName: expandVal?.staff?.name || "",
              signature: decrypt(sigObj?.signature) || null,
              signatureText: sigObj?.signatureText || null,
              signatureImage: decrypt(sigObj?.signatureImage) || null,
            });
          } else if (headerVal === "Time") {
            tempArr.push(expandVal?.time || "");
          } else if (headerVal === "Task Completed") {
            tempArr.push(
              expandVal?.tasks?.map((item) => item)?.join(", ") || ""
            );
          } else if (headerVal === "Activities Performed") {
            tempArr.push(expandVal?.activities || "");
          } else if (headerVal === "Notes") {
            tempArr.push(
              expandVal?.notes?.map((note) => note?.note)?.join(", ") || ""
            );
          }
        });

        allTempArr.push(tempArr);
      });

      return allTempArr;
    });
    const bodyArr = [];
    tempTasks?.map((item) => {
      bodyArr.push(...item);
    });

    await preloadSignatures(bodyArr);

    doc.autoTable({
      head: [filtersHead],
      body: bodyArr,
      startY: 100, // position table 20 units below
      headStyles: {
        halign: "center",
        valign: "middle",
        lineWidth: 0.25,
        fillColor: 200,
      },
      bodyStyles: {
        // halign: "center",
        lineWidth: 0.25,
        minCellHeight: 100,
        lineColor: 200,
      },
      margin: {
        top: 30,
      },
      alternateRowStyles: { fillColor: [255, 255, 255] },
      didParseRow: (data) => {
        if (data.section === "body") {
          const cell = data.row.cells[5]?.raw;
          if (cell) {
            let baseHeight = 20;
            if (cell.signature || cell.signatureImage) baseHeight += 40;
            if (cell.signatureText) baseHeight += 45;
            data.row.height = baseHeight;
          }
        }
      },

      didParseCell: (data) => {
        if (data.section === "body" && data.column.index === 5) {
          data.cell.text = [""];
        }
      },
      didDrawCell: (data) => {
        if (data.section === "body" && data.column.index === 5) {
          const cellData = data.cell.raw;
          if (!cellData) return;

          const cellX = data.cell.x + 5;
          const cellY = data.cell.y + 15;

          let nameHeight = 0;
          if (cellData.staffName) {
            doc.setFont("helvetica", "normal");
            doc.setFontSize(12);
            doc.text(cellData.staffName, cellX, cellY);
            nameHeight = 14;
          }

          let offsetY = cellY + nameHeight + 5;

          if (cellData?.signature || cellData?.signatureImage) {
            const sigSrc = cellData?.signature || cellData?.signatureImage;
            const imgWidth = 60;
            const imgHeight = 30;
            doc.addImage(sigSrc, "PNG", cellX, offsetY, imgWidth, imgHeight);
            offsetY += imgHeight + 5;
          }

          if (cellData.signatureText) {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = 200;
            canvas.height = 60;
            ctx.font = "32px 'Island Moments'";
            ctx.fillStyle = "#171717";
            ctx.textAlign = "left";
            ctx.fillText(cellData.signatureText, 10, 40);
            const imgData = canvas.toDataURL("image/png");

            doc.addImage(imgData, "PNG", cellX, offsetY, 100, 40);
          }
        }
      },
    });

    // doc.setFont("helvetica", "normal");
    // doc.setFontSize(12);
    // doc.text(
    //   `Signatured at: ${signatureTimePDF || ""}`,
    //   pageWidth - sigWidth - 20,
    //   pageHeight - 20
    // );

    doc.save("Ogiso Report.pdf");
    setPdfDownloadloading(false);
  };

  const noteHandlePDF = async () => {
    setPdfDownloadloading(true);
    // Create a new jsPDF instance
    var pdfsize = [1500, 1000]; //"a0";
    var doc = new jsPDF("l", "pt", pdfsize);
    const dataURL =
      "data:image/png;base64,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";
    doc.addImage(dataURL, "PNG", 13, 10, 80, 40);
    doc.setFont("helvetica", "bold");
    doc.text(data?.data?.name || "", 750, 50, { align: "center" });
    doc.setFont("helvetica", "normal");
    doc.text(startDate, 1200, 70);
    doc.text("-", 1320, 70);
    doc.text(endDate, 1350, 70);

    const startX = 30;
    let startY = 100;

    if (filterField.length > 0) {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);
      doc.text("PARAMETERS" || "", 80, 70, { align: "center" });
      doc.setFont("helvetica", "normal");
      // Add text for each entry in filterField array

      let filtersHead = [["Source", "Field"]];
      let parameters = filterField?.map((filter) => {
        return [
          noteTypes?.ntypes?.find((value) => value?.id === filter?.source)
            ?.name,
          filter?.field,
          filter?.filterOn,
        ];
      });

      autoTable(doc, {
        head: filtersHead,
        body: parameters,
        startY: 100,
      });
    }

    Object.keys(filteredData).forEach((key, pageIndex) => {
      const entry = filteredData[key];

      // If it's the first page, add dummy text
      if (pageIndex >= 0) {
        startY = 30;
        doc.addPage();
      }

      autoTable(doc, {
        html: "#sampleTable",
        startY: 100,
        headStyles: {
          halign: "center",
          valign: "middle",
          lineWidth: 0.25,
          fillColor: 200,
          fontSize: 20,
        },
        bodyStyles: {
          // halign: "center",
          lineWidth: 0.25,
          lineColor: 200,
          minCellHeight: 130,
          fontSize: 20,
        },
        margin: {
          top: 30,
        },
        alternateRowStyles: { fillColor: [255, 255, 255] },
        didParseCell: (data) => {
          if (data.section === "body" && data.column.index === 6) {
            const textEl = data.cell.raw?.querySelector("span, p, div");

            if (textEl && textEl.textContent.trim()) {
              const fullText = data.cell.text.join(" ");
              const signatureText = textEl.textContent.trim();
              const staffName = fullText.replace(signatureText, "").trim();

              if (staffName && staffName !== "Staff Name") {
                data.cell.text = [staffName];

                const fontSize = data.cell.styles.fontSize || 20;
                const lineHeight = fontSize * 0.35; // jsPDF approx line-height ratio
                data.cell._staffNameHeight = lineHeight;
              }
            }
          }
        },

        didDrawCell: (data) => {
          if (data.section === "body" && data.column.index === 6) {
            const staffEl = data.cell.raw?.querySelector(".staff-name");
            const signEl = data.cell.raw?.querySelector(".signature");

            if (!staffEl || !signEl) return;

            const staffName = staffEl.textContent.trim();

            data.cell.text = [staffName];
            const staffRect = staffEl.getBoundingClientRect();
            const staffHeight = staffRect.height || 20;

            if (signEl.tagName === "IMG") {
              const imgSrc = signEl.getAttribute("src");
              if (imgSrc) {
                const imgX = data.cell.x + 2;
                const imgW = data.cell.width - 4;
                const imgH = 40;

                const staffRect = staffEl.getBoundingClientRect();
                const staffHeight = staffRect.height || 20;

                const imgY = data.cell.y + staffHeight + 60;

                doc.addImage(imgSrc, "PNG", imgX, imgY, imgW, imgH);
              }
            } else {
              const signatureText = signEl.textContent.trim();
              if (signatureText) {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = 400;
                canvas.height = 100;
                ctx.font = "78px 'Island Moments'";
                ctx.fillStyle = "#171717";
                ctx.textAlign = "center";
                ctx.fillText(signatureText, canvas.width / 2, 70);
                const imgData = canvas.toDataURL("image/png");

                const imgX = data.cell.x + 2;
                const imgW = data.cell.width - 4;
                const imgH = 40;
                const imgY = data.cell.y + staffHeight + 10;

                doc.addImage(imgData, "PNG", imgX, imgY, imgW, imgH);
              }
            }
          }
        },
      });
    });
    doc.save("Ogiso Report.pdf");
    setPdfDownloadloading(false);
  };

  const marHandlePDF = () => {
    setPdfDownloadloading(true);
    // Create a new jsPDF instance
    var pdfsize = [1500, 1000]; //"a0";
    var doc = new jsPDF("l", "pt", pdfsize);
    const dataURL =
      "data:image/png;base64,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";
    doc.addImage(dataURL, "PNG", 13, 10, 80, 40);
    doc.setFont("helvetica", "bold");
    doc.text(data?.data?.name || "", 750, 50, { align: "center" });
    doc.setFont("helvetica", "normal");
    doc.text(startDate, 1200, 70);
    doc.text("-", 1320, 70);
    doc.text(endDate, 1350, 70);

    const startX = 30;
    let startY = 100;

    autoTable(doc, {
      html: "#sampleTable",
      startY: 100,
      headStyles: {
        halign: "center",
        valign: "middle",
        lineWidth: 0.25,
        fillColor: 200,
      },
      bodyStyles: {
        // halign: "center",
        lineWidth: 0.25,
        lineColor: 200,
        minCellHeight: 100,
      },
      columnStyles: {
        10: { cellWidth: 150 },
      },
      margin: {
        top: 30,
      },
      alternateRowStyles: { fillColor: [255, 255, 255] },
      didParseRow: (data) => {
        if (data.section === "body") {
          const cell = data.row.cells[10]?.raw;
          if (cell) {
            let baseHeight = 20; // staff name
            if (cell.querySelector("img")) baseHeight += 40; // image height
            if (cell.querySelector(".signature")) baseHeight += 45; // text signature height
            data.row.height = baseHeight;
          }
        }
      },
      didParseCell: (data) => {
        if (data.section === "body" && data.column.index === 10) {
          const staffEl = data.cell.raw?.querySelector(".staff-name");
          if (staffEl) {
            data.cell.text = [];
          }
        }
      },

      didDrawCell: (data) => {
        if (data.column.index === 10 && data.cell.section === "body") {
          const staffName =
            data.cell.raw?.querySelector(".staff-name")?.innerText || "";
          const imgEl = data.cell.raw?.querySelector("img");
          const textEl = data.cell.raw?.querySelector(".signature");

          const textX = data.cell.x + 2;
          let textY = data.cell.y + 12;

          // Staff Name
          if (staffName) {
            doc.setFont("helvetica", "normal");
            doc.setFontSize(12);
            doc.text(staffName, textX, textY);
            textY += 18;
          }

          // Signature Image
          if (imgEl) {
            const src = imgEl.getAttribute("src");
            if (src) {
              doc.addImage(src, "PNG", textX, textY, 60, 30);
              textY += 35;
            }
          }

          // Signature Text
          if (textEl) {
            const sigText = textEl.innerText;
            if (sigText) {
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");
              canvas.width = 200;
              canvas.height = 60;
              ctx.font = "32px 'Island Moments'";
              ctx.fillStyle = "#171717";
              ctx.textAlign = "left";
              ctx.fillText(sigText, 10, 40);
              const imgData = canvas.toDataURL("image/png");
              doc.addImage(imgData, "PNG", textX, textY, 100, 40);
            }
          }
        }
      },
    });

    doc.save("Ogiso Report.pdf");
    setPdfDownloadloading(false);
  };

  const sendReport = async () => {
    // Create a new jsPDF instance

    var pdfsize = [1500, 1000]; //"a0";
    var doc = new jsPDF("l", "pt", pdfsize);
    // const doc = new jsPDF();
    const dataURL =
      "data:image/png;base64,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";
    doc.addImage(dataURL, "PNG", 13, 10, 80, 40);
    doc.setFont("helvetica", "bold");
    doc.text(data?.data?.name || "", 750, 50, { align: "center" });
    doc.setFont("helvetica", "normal");
    doc.text(startDate, 1200, 70);
    doc.text("-", 1320, 70);
    doc.text(endDate, 1350, 70);

    const startX = 30;
    let startY = 100;

    if (filterField.length > 0) {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);
      doc.text("PARAMETERS" || "", 80, 70, { align: "center" });
      doc.setFont("helvetica", "normal");
      // Add text for each entry in filterField array

      let filtersHead = [["Source", "Field"]];
      let parameters = filterField?.map((filter) => {
        return [
          noteTypes?.ntypes?.find((value) => value?.id === filter?.source)
            ?.name,
          filter?.field,
          filter?.filterOn,
        ];
      });
      autoTable(doc, {
        head: filtersHead,
        body: parameters,
        startY: 100,
      });
    }

    Object.keys(filteredData).forEach((key, pageIndex) => {
      const entry = filteredData[key];

      if (pageIndex >= 0) {
        startY = 30;
        doc.addPage();
      }

      let body = entry.data.slice(1).map((row, rowIndex) => {
        return [
          entry?.source?.name,
          ...row.map((cell, cellIndex) => {
            const cellText = cell !== undefined ? cell.toString() : "";
            return cellText;
          }),
        ];
      });

      let head = ["Note Type", ...entry.data[0]?.map((v) => v)];

      autoTable(doc, {
        head: [head],
        body,
      });
    });
    const buff = doc.output("blob");
    const formdata = new FormData();
    formdata.append("file", new File([buff], "filename"));
    formdata.append("email", emailState);

    let response = await sendReportEmail(formdata);
    if (response) {
      showInfo("Email sent successfully");
      // setLoading(false);
    }
  };

  const [secondModalOpen, setSecondModalOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const openSecondModal = () => {
    onclose();
    setViewEmail(true);
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleSecondModalButtonClick = () => {
    // Close the second modal
    setSecondModalOpen(false);
  };

  const { patients } = useSelector((state) => state.patient);

  return (
    <>
      <Modal
        className={classes.mymodal}
        opened={opened}
        size={1800}
        onClose={() => {
          removeFilters();
          onclose();
        }}
        shadow="md"
        overlayProps={{ blur: 3 }}
        zIndex={1000}
        title={
          <Group>
            <img src="/assets/images/addfac.png" alt="" />
            <Text sx={{ fontFamily: "Inter", fontSize: 22 }}>{title}</Text>
          </Group>
        }
        centered
      >
        <Container
          fluid
          sx={{
            width: "100%",
            borderTopColor: "#EDEDED",
            borderTopStyle: "solid",
            borderTopWidth: 2,
          }}
          m={0}
          p={0}
          pt={10}
        >
          <Grid className={classes.mainContainer}>
            {data?.data?.reportType !== "mar" ? (
              <Grid.Col span={3}>
                <Text sx={{ marginLeft: 20 }}>
                  <span className={classes.title}>Report Name:</span>{" "}
                  <span className={classes.name}>{data?.data?.name || ""}</span>
                </Text>
                <Card
                  shadow="sm"
                  p={15}
                  sx={{
                    marginTop: 41,
                    marginBottom: 20,
                    height: "65vh",
                  }}
                >
                  <Card.Section>
                    <div>
                      <Group className={classes.filterHeader}>
                        <ActionIcon color="yellow" variant="light">
                          <IconFilter color="#FFBA45" />
                        </ActionIcon>
                        <Text ff={"Inter"} fz={22} fw={500}>
                          Filters
                        </Text>

                        <Badge color="yellow" size="lg">
                          {filters?.length}
                        </Badge>
                        <Button
                          color="yellow"
                          radius={8}
                          onClick={removeFilters}
                          className={classes.btn}
                          variant="light"
                        >
                          Clear
                        </Button>
                      </Group>
                    </div>
                  </Card.Section>

                  <Container className={classes.filters}>
                    <Grid
                      columns={14}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <form>
                        <Grid.Col
                          span={14}
                          sx={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "flex-end",
                          }}
                        ></Grid.Col>
                        {filters?.map((value, index) => (
                          <Grid.Col span={12} key={index}>
                            <div
                              style={{
                                display: "flex",
                                gap: 10,
                                width:
                                  index === filters?.length - 1
                                    ? "115%"
                                    : "100%",
                              }}
                            >
                              <Box className={classes.filter}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  {index !== filters?.length - 1 ? (
                                    <span
                                      onClick={() => removeFilter(value?.id)}
                                      className={classes.deleteBTN}
                                    >
                                      Delete
                                    </span>
                                  ) : null}
                                </div>
                                <Select
                                  searchable
                                  label={"Source"}
                                  placeholder="Select Source"
                                  data={sourceOptions}
                                  value={value?.source}
                                  onChange={(source) =>
                                    onChangeSource(source, value?.id)
                                  }
                                  size="md"
                                />

                                <Select
                                  searchable
                                  label={"Field"}
                                  placeholder="Select Field Type"
                                  data={value?.fieldOptions}
                                  value={value?.fieldValue}
                                  onChange={(fieldToFilter) =>
                                    onChangeField(fieldToFilter, value?.id)
                                  }
                                  size="md"
                                />
                                <Select
                                  searchable
                                  label={"Field Value"}
                                  placeholder="Select Field Value"
                                  data={value?.filterOptions}
                                  onChange={(filter) =>
                                    onChangeFieldValue(filter, value?.id)
                                  }
                                  value={value?.filterOn}
                                  size="md"
                                />
                              </Box>
                              {index === filters?.length - 1 ? (
                                <ActionIcon
                                  color="yellow"
                                  variant="filled"
                                  onClick={addEmptyFilter}
                                  sx={{
                                    marginTop: "auto",
                                  }}
                                >
                                  <img
                                    src="/assets/images/filter-add.png"
                                    alt=""
                                  />
                                </ActionIcon>
                              ) : null}
                            </div>
                          </Grid.Col>
                        ))}
                      </form>
                    </Grid>
                  </Container>

                  <Center>
                    <Text style={{ color: "red", fontSize: "12px" }}>
                      {error || ""}
                    </Text>
                    <Button
                      color="yellow"
                      className={classes.saveBTN}
                      onClick={sendFilters}
                    >
                      Save
                    </Button>
                  </Center>
                </Card>
              </Grid.Col>
            ) : (
              <Grid.Col span={3}>
                <Text sx={{ marginLeft: 20 }}>
                  <span className={classes.title}>Report Name:</span>{" "}
                  <span className={classes.name}>{data?.data?.name || ""}</span>
                </Text>
                <Card
                  shadow="sm"
                  p={15}
                  sx={{
                    marginTop: 41,
                    marginBottom: 20,
                    height: "65vh",
                  }}
                >
                  <Card.Section>
                    <div>
                      <Group className={classes.filterHeader}>
                        <ActionIcon color="yellow" variant="light">
                          <IconFilter color="#FFBA45" />
                        </ActionIcon>
                        <Text ff={"Inter"} fz={22} fw={500}>
                          Filters
                        </Text>

                        <Badge color="yellow" size="lg">
                          {filters?.length}
                        </Badge>
                        <Button
                          color="yellow"
                          radius={8}
                          onClick={removeFilters}
                          className={classes.btn}
                          variant="light"
                        >
                          Clear
                        </Button>
                      </Group>
                    </div>
                  </Card.Section>

                  <Container className={classes.filters}>
                    <Grid
                      columns={14}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <form>
                        <Grid.Col
                          span={14}
                          sx={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "flex-end",
                          }}
                        ></Grid.Col>
                        {filters?.map((value, index) => (
                          <Grid.Col span={12} key={index}>
                            <div
                              style={{
                                display: "flex",
                                gap: 10,
                                width:
                                  index === filters?.length - 1
                                    ? "115%"
                                    : "100%",
                              }}
                            >
                              <Box className={classes.filter}>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  {index !== filters?.length - 1 ? (
                                    <span
                                      onClick={() => removeFilter(value?.id)}
                                      className={classes.deleteBTN}
                                    >
                                      Delete
                                    </span>
                                  ) : null}
                                </div>
                                {/* <Select
                                  searchable
                                  label={"Source"}
                                  placeholder="Select Source"
                                  data={sourceOptions}
                                  value={value?.source}
                                  onChange={(source) =>
                                    onChangeSource(source, value?.id)
                                  }
                                  size="md"
                                /> */}

                                <Select
                                  searchable
                                  label={"Field"}
                                  placeholder="Select Field Type"
                                  // data={value?.fieldOptions}
                                  data={marFieldOptions || []}
                                  value={value?.fieldValue}
                                  onChange={(fieldToFilter) =>
                                    onChangeMarField(fieldToFilter, value?.id)
                                  }
                                  size="md"
                                />
                                <Select
                                  searchable
                                  label={"Field Value"}
                                  placeholder="Select Field Value"
                                  data={value?.filterOptions}
                                  onChange={(filter) =>
                                    onChangeFieldValue(filter, value?.id)
                                  }
                                  value={value?.filterOn}
                                  size="md"
                                />
                              </Box>
                              {index === filters?.length - 1 ? (
                                <ActionIcon
                                  color="yellow"
                                  variant="filled"
                                  onClick={addEmptyFilter}
                                  sx={{
                                    marginTop: "auto",
                                  }}
                                >
                                  <img
                                    src="/assets/images/filter-add.png"
                                    alt=""
                                  />
                                </ActionIcon>
                              ) : null}
                            </div>
                          </Grid.Col>
                        ))}
                      </form>
                    </Grid>
                  </Container>

                  <Center>
                    <Text style={{ color: "red", fontSize: "12px" }}>
                      {error || ""}
                    </Text>
                    <Button
                      color="yellow"
                      className={classes.saveBTN}
                      onClick={sendFilters}
                    >
                      Save
                    </Button>
                  </Center>
                </Card>
              </Grid.Col>
            )}
            <Grid.Col span={"auto"} style={{ overflowX: "auto" }}>
              <Container sx={{ width: "100%" }} fluid p={0}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  {data?.data?.reportType !== "mar" && (
                    <Text
                      sx={{ fontFamily: "Inter", fontSize: 20, marginTop: 25 }}
                    >
                      Total no. of Records: {length}
                    </Text>
                  )}
                  <Group sx={{ marginLeft: "auto", marginRight: 30 }}>
                    <ReportButton
                      title={"Email Report"}
                      onClick={openSecondModal}
                    />

                    <Modal
                      opened={secondModalOpen}
                      onClose={() => setSecondModalOpen(false)}
                      className={classes.emailModal}
                    >
                      <div style={{ padding: 20 }}>
                        <Input
                          value={inputValue}
                          onChange={handleInputChange}
                          placeholder="Enter something"
                        />
                        <Button onClick={handleSecondModalButtonClick}>
                          Submit
                        </Button>
                      </div>
                    </Modal>
                    <ReactHTMLTableToExcel
                      id="test-table-xls-button"
                      className="download-table-xls-button"
                      // table="sampleTable"
                      table="hiddenTable"
                      filename="Report"
                      sheet="tablexls"
                      buttonText={
                        <ActionIcon>
                          <img src="/assets/images/xlsDowload.png" alt="" />
                        </ActionIcon>
                      }
                    />

                    <ActionIcon
                      ml={15}
                      disabled={pdfDownloadloading}
                      onClick={() => {
                        data?.data?.reportType === "task"
                          ? taskHandlePDF()
                          : data?.data?.reportType === "mar"
                          ? marHandlePDF()
                          : noteHandlePDF();
                      }}
                    >
                      {pdfDownloadloading ? (
                        <Loader color="#000000" size="sm" />
                      ) : (
                        <img src="/assets/images/pdf.png" alt="" />
                      )}
                    </ActionIcon>
                  </Group>
                </Box>
                <div
                  style={{
                    maxHeight: "500px",
                    "@media (maxWidth :40em)": { maxHeight: "300px" },
                    overflowY: "auto",
                    margin: "1rem 0",
                  }}
                >
                  {data?.data?.reportType === "task" ? (
                    <TaskReportViewTable
                      data={tables?.[0]}
                      tables={tables}
                      reportData={data?.data}
                      ref={ref}
                      onFiltered={setFiltered}
                      setFilteredTasks={setFilteredTasks}
                      setLength={setLength}
                    />
                  ) : data?.data?.reportType === "mar" ? (
                    <MARReportViewTable
                      data={marTable?.[0]}
                      tables={marTable}
                      loading={marLoading}
                      reportData={data?.data}
                      ref={ref}
                      onFiltered={setFiltered}
                      filteredMar={filteredMar}
                      setFilteredMar={setFilteredMar}
                    />
                  ) : hasProgressNote ? (
                    <ReportViewTableProgress
                      data={tables?.[0]}
                      tables={tables}
                      reportData={data?.data}
                      ref={ref}
                      onFiltered={setFiltered}
                      // signature={data?.signature}
                    />
                  ) : hasEssentialNote ? (
                    <ReportViewTableEssentialNote
                      data={tables?.[0]}
                      tables={tables}
                      reportData={data?.data}
                      ref={ref}
                      onFiltered={setFiltered}
                    />
                  ) : hasInterventionNote ? (
                    <ReportViewTableIntervention
                      data={tables?.[0]}
                      tables={tables}
                      reportData={data?.data}
                      ref={ref}
                      onFiltered={setFiltered}
                    />
                  ) : (
                    <ReportViewTable
                      data={tables?.[0]}
                      tables={tables}
                      reportData={data?.data}
                      ref={ref}
                      onFiltered={setFiltered}
                    />
                  )}
                </div>
              </Container>
            </Grid.Col>
          </Grid>
        </Container>
      </Modal>

      <ReportEmailModal
        viewEmail={viewEmail}
        setViewEmail={setViewEmail}
        emailState={emailState}
        setEmailState={setEmailState}
        submitFn={sendReport}
      />
    </>
  );
};

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
  btn: {
    marginLeft: "auto",
    width: 122,
  },
  mymodal: {
    zIndex: "10",
    margin: "1rem 0",
    "& .mantine-16fdnqw": {
      flexWrap: "nowrap",
    },
    "& .mantine-65xaze": {
      overflowY: "hidden",
      overflowX: "hidden",
    },
    height: "100%",
    "& .mantine-Modal-inner": {
      padding: "5px",
    },
  },
  emailModal: {
    zIndex: 20,
  },
  mwd: {
    width: "100%",
  },
  filters: {
    width: "100%",
    overflowY: "auto",
    overflowX: "hidden",
    maxHeight: "350px",
    "@media (max-width :1024px)": {
      maxHeight: "200px",
      padding: "1rem",
    },
  },
  filter: {
    borderRadius: 10,
    borderColor: "#FFBA4599",
    borderStyle: "solid",
    borderWidth: 1,
    padding: 12,
    marginTop: 15,
  },
  filterHeader: {
    marginTop: 15,
    marginLeft: 15,
    marginRight: 15,
    borderBottomColor: "#CBCBCB66",
    borderBottomStyle: "solid",
    borderBottomWidth: 1,
    paddingBottom: 15,
  },
  title: {
    fontFamily: "Inter",
    fontSize: 22,
    fontWeight: 500,
    color: "#232323",
  },
  name: {
    fontFamily: "Inter",
    fontSize: 22,
    fontWeight: 500,
    color: "#FFBA45",
  },
  saveBTN: {
    width: 122,
    position: "absolute",
    bottom: 15,
    fontFamily: "Inter",
    fontSize: 16,
  },
  deleteBTN: {
    color: "#fab005",
    textDecoration: "underline",
    cursor: "pointer",
  },
  signatureContainer: {
    width: "100%",
    overflow: "hidden",
    display: "flex",
    justifyContent: "flex-end",
  },
  signature: {
    width: "150px",
    height: "150px",
    objectFit: "contain",
  },
}));

export default ReportViewModal;
